import { render } from "./TradeSettingsPopover.vue?vue&type=template&id=0b41a822"
import script from "./TradeSettingsPopover.vue?vue&type=script&lang=ts"
export * from "./TradeSettingsPopover.vue?vue&type=script&lang=ts"

import "./TradeSettingsPopover.vue?vue&type=style&index=0&id=0b41a822&lang=css"
script.render = render

export default script